<!-- 实物审批-点击查看实物寄件信息按钮-查看 -->
<template>
	<el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" class="role-dialog" width="70%">
		<span slot="title" class="dialog-title">
			<img src="@/assets/images/close.png" alt="" @click="visible = false" />
		</span>
		<el-form :model="dataForm" label-position="top" ref="dataForm">
			<el-form-item label="快递单号" prop="expressNumber">
				<el-input readonly v-model="dataForm.expressNumber" placeholder="如果没有快递单号则填无"></el-input>
			</el-form-item>
			<div class="flex">
				<div class="flex-1 mr10">
					<el-tag>寄件方</el-tag>
					<el-form-item label="" prop="sendAdvanceCode">
						<el-select readonly v-model="dataForm.sendAdvanceCode">
							<el-option
								v-for="item in sendOptions"
								:key="item.advanceCode"
								:label="`${item.advanceCode}/${item.companyName}/${item.address}/${item.telephone}/${item.contact}`"
								:value="item.advanceCode"></el-option>
						</el-select>
					</el-form-item>
					<div class="flex">
						<div class="flex-1 mr10">
							<el-form-item label="省" prop="sendProvince">
								<el-input readonly v-model="dataForm.sendProvince" placeholder="请输入"></el-input>
							</el-form-item>
						</div>
						<div class="flex-1 ml10">
							<el-form-item label="市" prop="sendCity">
								<el-input readonly v-model="dataForm.sendCity" placeholder="请输入"></el-input>
							</el-form-item>
						</div>
					</div>
					<el-form-item label="详细地址" prop="sendAddressDetail">
						<el-input readonly v-model="dataForm.sendAddressDetail" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="sendPhone">
						<el-input readonly v-model="dataForm.sendPhone" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="姓名" prop="sendUserName">
						<el-input readonly v-model="dataForm.sendUserName" placeholder="请输入"></el-input>
					</el-form-item>
				</div>
				<div class="flex-1 ml10">
					<el-tag type="danger">收件方</el-tag>
					<el-form-item label="" prop="deliveryAdvanceCode">
						<el-select readonly v-model="dataForm.deliveryAdvanceCode">
							<el-option
								v-for="item in deliveryOptions"
								:key="item.advanceCode"
								:label="`${item.advanceCode}/${item.companyName}/${item.address}/${item.telephone}/${item.contact}`"
								:value="item.advanceCode"></el-option>
						</el-select>
					</el-form-item>
					<div class="flex">
						<div class="flex-1 mr10">
							<el-form-item label="省" prop="deliveryProvince">
								<el-input readonly v-model="dataForm.deliveryProvince" placeholder="请输入"></el-input>
							</el-form-item>
						</div>
						<div class="flex-1 ml10">
							<el-form-item label="市" prop="deliveryCity">
								<el-input readonly v-model="dataForm.deliveryCity" placeholder="请输入"></el-input>
							</el-form-item>
						</div>
					</div>
					<el-form-item label="详细地址" prop="deliveryAddressDetail">
						<el-input readonly v-model="dataForm.deliveryAddressDetail" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="deliveryPhone">
						<el-input readonly v-model="dataForm.deliveryPhone" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="姓名" prop="deliveryUserName">
						<el-input readonly v-model="dataForm.deliveryUserName" placeholder="请输入"></el-input>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button type="info" @click="visible = false">取消</el-button>
		</span>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
			sendOptions: [],
			deliveryOptions: [],
			dataForm: {
				linkId: "",
				linkTable: "parts_claim_warranty",
				expressType: "1",
				expressNumber: "",
				sendAdvanceCode: "",
				sendProvince: "",
				sendCity: "",
				sendDistrict: "",
				sendAddressDetail: "",
				sendPhone: "",
				sendUserName: "",
				deliveryAdvanceCode: "",
				deliveryProvince: "",
				deliveryCity: "",
				deliveryDistrict: "",
				deliveryAddressDetail: "",
				deliveryPhone: "",
				deliveryUserName: "",
			},
		};
	},
	methods: {
		init(faultyExpress) {
			this.visible = true;
			this.$nextTick(() => {
				console.log(faultyExpress);
				this.dataForm = faultyExpress;
				this.getClaimRepairAdvance("0", faultyExpress.sendAdvanceCode);
				this.getClaimRepairAdvance("1", faultyExpress.deliveryAdvanceCode);
			});
		},
		// 获取邮寄地址
		getClaimRepairAdvance(type, advanceCode) {
			let self = this;
			const params = {
				advanceCode: advanceCode,
			};
			self.$request.post("getClaimRepairAdvance", false, params, function (r) {
				if (r.code == "0") {
					if (type == "0") {
						self.sendOptions = r.data.slice(0, 10);
					}
					if (type == "1") {
						self.deliveryOptions = r.data.slice(0, 10);
					}
				} else {
					self.$message.error(r.msg);
				}
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.el-form-item {
	margin-bottom: 10px;

	.el-select {
		width: 100%;
	}
}

.submit-btn {
	background-color: #117ffc;
	color: #fff;
}

.role-dialog /deep/ .el-dialog {
	border-radius: 10px !important;
}

.role-dialog /deep/ .el-dialog__body {
	padding: 0 20px !important;
}

.role-dialog /deep/ .el-form-item__label {
	padding: 0 !important;
}

.role-dialog /deep/ .el-dialog__footer {
	padding: 20px 20px 40px !important;
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
}
.ml10 {
	margin-left: 10px;
}
.mr10 {
	margin-right: 10px;
}
.mt10 {
	margin-top: 10px;
}
.el-tag {
	margin-bottom: 10px;
}
</style>
